'use client'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useRouter } from 'next/navigation';
import { toast } from 'react-toastify';
import { getCookie, login } from '@/app/lib/api-service';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const router = useRouter();

    useEffect(() => {
        const cookie = getCookie("username");
        if (cookie) {
            window.location.href = '/report';
        }
    }, []);

    const handleLogin = async () => {
        if (!username || !password) {
            toast.error('Бүх талбарыг бөглөнө үү.');
            return;
        }
        setLoading(true);
        try {
            await login(username, password);
            toast.success('Амжилттай нэвтэрлээ');
            router.push('/report');
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response?.status === 400 || error.response?.status === 401) {
                    toast.error('Нэвтрэх боломжгүй байна. Та имэйл болон нууц үгээ шалгана уу.');
                    setPassword('');
                } else {
                    toast.error('Системд холбогдоход алдаа гарлаа. Та дараа дахин оролдоно уу.');
                }
            } else {
                toast.error('Системд холбогдоход алдаа гарлаа. Та дараа дахин оролдоно уу.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (e: { key: string }) => {
        if (e.key === 'Enter' && !loading) {
            handleLogin();
        }
    };

    return (
        <div className="h-screen w-screen bg-login bg-cover bg-center bg-no-repeat">
            <div className="flex flex-col justify-center items-center h-screen">
                <div className="w-full max-w-sm p-8 bg-transparent backdrop-blur-md bg-opacity-10 shadow-md rounded-xl space-y-5 border-white border-opacity-45 border-[1px]">
                    <h1 className="text-2xl font-semibold mb-3 text-center text-white">Тавтай морил!</h1>
                    <input
                        type="text"
                        placeholder="Имэйл"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="text-sm w-full px-4 py-3 border border-white rounded-3xl mb-4 text-white bg-transparent placeholder:text-white focus:outline-white focus:text-gray-800  focus:bg-white"
                        disabled={loading}
                    />
                    
                    <input
                        type="password"
                        placeholder="Нууц үг"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="text-sm w-full px-4 py-3 border border-white rounded-3xl mb-4 text-white bg-transparent placeholder:text-white focus:outline-white focus:text-gray-800  focus:bg-white"
                        disabled={loading}
                    />
                    
                    <button
                        onClick={handleLogin}
                        className="cursor-pointer w-full h-12 font-semibold px-4 text-md bg-white text-dark-700 rounded-3xl active:bg-gray-100 flex justify-center items-center disabled:bg-gray-100 disabled:cursor-not-allowed"
                        disabled={loading}
                    >
                        {loading ? (
                            <svg className="animate-spin h-5 w-5 mr-2 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l4-4-4-4v4a8 8 0 00-8 8z"></path>
                            </svg>
                        ) : (
                            'Нэвтрэх'
                        )}
                    </button>

                    {/* <div className="mt-8 pt-5 border-t-2 border-gray-200 text-center text-sm">
                        <div>
                            <span className="text-center text-white">Нууц үгээ мартсан?</span>
                            <Link href="/recover">
                                <span className="ms-2 font-semibold text-center underline hover:cursor-pointer text-white">Сэргээх</span>
                            </Link>
                        </div>
                        <div className="mt-2">
                            <span className="text-center text-white">Бүртгэлгүй?</span>
                            <Link href="/register">
                                <span className="ms-2 font-semibold text-center underline hover:cursor-pointer text-white">Бүртгүүлэх</span>
                            </Link>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
